import { observer } from "mobx-react";
import fulfillmentLocationImage from "../../../../../images/fullfilment-location.png";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import "./onboarding-fulfillment-location-view.scss";


const OnboardingFulfillmentLocationView: React.FC = observer(() => {
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-onboarding';

    return(
        <div className="onboarding-fulfillment-location-view">
            <img src={fulfillmentLocationImage} alt="fulfillment location" />
            <FontBody1 color={FONT_COLOR.PRIMARY2}>{getTranslation('FULFILLMENT_LOCATION_DESCRIPTION', scope)}</FontBody1>
        </div>
    );
});

export default OnboardingFulfillmentLocationView;